import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {FlatIconColor, FlatIconColorType, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {noop} from '@Utils/general.util';
import {ClickableDiv} from '@Components/clickable-div';
import styles from './add-account-icon.module.scss';

interface AddAccountIconProps {
  isLoading?: boolean;
  isDisabled?: boolean;
  className?: string;
  size?: IconSize;
  onClick?: VoidFunction;
}

export function AddAccountIcon({isLoading = false, isDisabled = false, className = '', size = IconSize.SIZE_ICON_16, onClick = noop}: AddAccountIconProps): ReactElement<AddAccountIconProps> | null {
  const getIcon = (): ReactElement => {
    return (
      <Icon
        isLoading={isLoading}
        isDisabled={isDisabled}
        icon="icon-plus"
        size={size}
        type={IconType.FLAT}
        flatIconType={{color: FlatIconColor.NEUTRAL, type: FlatIconColorType.DEFAULT}}
      />
    );
  };

  const getClickHandler = (): VoidFunction => {
    if (isDisabled) {
      return noop;
    }

    return onClick;
  };

  const getClasses = (): string => {
    return `${styles.addAccount} ${className} spacing-m-l-1 ${isDisabled ? styles.addAccountDisabled : '_cursor-pointer'}`;
  };

  return (
    <ClickableDiv aria-disabled={isDisabled} onClick={getClickHandler()} className={getClasses()}>
      {getIcon()}
    </ClickableDiv>
  );
}
